import vueRouter from 'vue-router'
import WapSoso from '@/views/search/synthesisAfter'
import Share from '@/views/search/share'
import upLoadArt from '@/views/search/upLoadArt'
import WapSosoResult from '@/views/search/WapSosoResult'
import preview from '@/views/preview/preview'
import previewNew from '@/views/previewNew/preview'

import rankList from '@/views/preview/rankList'
import quotations from '@/views/preview/quotations'
import collectList from '@/views/preview/collectList'
import collectDetails from '@/views/preview/collectDetails'
import organVideoList from '@/views/preview/organVideoList'
import videoPlay from '@/views/preview/videoPlay'
import mapPosition from '@/views/preview/mapPosition'
import reportList from '@/views/preview/reportList'
import WapSosoResultpaipin from '@/views/search/WapSosoResultPai'
import WapSosomarket from '@/views/search/market'
import WapSosoinfor from '@/views/search/inforM'
import pinselect from '@/views/search/Wappinselect'
import Select from '@/views/meeting/searchSpecial'
import WapSosoResultPaiCompany from '@/views/search/WapSosoResultPaiCompany'
import WapSelect from '@/views/search/WapSelect'
import ProductDetail from '@/views/data/ProductDetail'
import News from '@/views/news/index'
import newsList from '@/views/newsList/index'
import sessionDetail from '@/views/meeting/sessionDetail'
import searchSpecialDetail from '@/views/meeting/searchSpecialDetail'
export default function createRouter() {
    return new vueRouter({
        mode: 'history', //一定要是history模式
        routes: [
            {
                path: "/",
                name: 'home',
                component: resolve => require([`./views/index`], resolve)
            },
           
            {
                path: "/share",
                name: 'share',
                component: Share /*分享落地页*/
            },
            {
                path: "/upLoadArt",
                name: 'upLoadArt',
                component: upLoadArt /*上传拍品*/
            },
            {
                path: "/quotations",
                name: 'quotations',
                component: quotations /*行情*/
            },
            {
                path: "/collectList",
                name: 'collectList',
                component: collectList /*秋拍征集*/
            },
            {
                path: "/collectDetails",
                name: 'collectDetails',
                component: collectDetails /*秋拍征集详情*/
            },
            
            
            // 全局搜索页面
            
            {
                path: "/search/all",
                name: 'search',
                component: WapSoso /*搜索页-综合*/
            },
            {
                path: "/search/company",
                name: 'company',
                component: WapSosoResultPaiCompany /*搜索-拍卖公司*/
            },
            {
                path: "/search/auction",
                name: 'paipin',
                component: WapSosoResultpaipin /*搜索-拍品*/
            },
            {
                path: "/search/meeting",
                name: 'paiacution',
                component: WapSosoResult /*搜索-拍卖会*/
            },
            {
                path: "/search/market",
                name: 'market',
                component: WapSosomarket /*搜索-市场报告*/
            },
            {
                path: "/search/news",
                name: 'infor',
                component: WapSosoinfor /*搜索-资讯*/
            },
            {
                path: "/select/auction",
                name: "pinselect",
                component: pinselect/*搜索拍品筛选*/
            },
            {
                path: "/data/select",
                name: 'select',
                component: WapSelect /*拍卖数据-筛选*/
            },
            {
                path: "/session/detail",
                name: 'session_detail',
                component: sessionDetail /*拍卖会跳转详情*/
            },
            {
                path: "/special/detail",
                name: 'search_special_detail',
                component: searchSpecialDetail /*拍卖专场跳转详情*/
            },
            {
                path: "/special/search",
                name: 'special_search_result',
                component: resolve => require([`./views/search/WapSpecialSearch`], resolve) /*拍卖专场跳转搜索*/
            },
            {
                path: "/organ/detail",
                name: 'organdetail',
                component: resolve => require([`./views/organ/detail`], resolve) /*机构跳转详情*/
            },
            /*拍卖会预展页面*/
            {
                path: "/preview",
                name: 'preview',
                component: 
                preview, /*拍卖机构*/
            },
            /*拍卖会预展页面*/
            {
                path: "/previewNew",
                name: 'previewNew',
                component: 
                previewNew, /*拍卖机构*/
            },
            {
                path: "/preview/search/upcoming",
                name: 'previewSearchUpcoming',
                component: () => import('./views/preview/search-upcoming.vue'),
            },
            {
                path: "/preview/search/result",
                name: 'previewSearchResult',
                component: () => import('./views/preview/search-results.vue'),
            },
            {
                path: "/rankList",
                name: 'rankList',
                component: rankList, /*拍卖机构*/
            },
            {
                path: "/reportList",
                name: 'reportList',
                component: reportList, /*拍卖机构*/
            },
            {
                path: "/auction",
                name: 'auction',
                component: resolve => require([`./views/preview/component/auction`], resolve) /*拍卖机构*/
            },
            // +++++++++++++++++++++++++++++++++++++++++++++++++++++
            {
                path:'/productdetail/:id',
                name:'productdetail',
                component: ProductDetail /*拍品底层*/
            },
            {
                path:'/news',
                name:'news',
                component: News /*新闻列表*/
            },
            {
                path:'/expertForm',
                name:'expertForm',
                component: () => import('./views/expertForm/index.vue')
            },
            {
                path:'/newsList',
                name:'newsList',
                component: () => import('./views/newsList/index.vue')
            },
            
            {
                path:'/videoPlay',
                name:'videoPlay',
                component: videoPlay /*视频播放页*/
            },
            {
                path:'/mapPosition',
                name:'mapPosition',
                component: mapPosition /*地图页*/
            },
            {
                path:'/organVideoList',
                name:'organVideoList',
                component: organVideoList /*机构视频列表*/
            },
            
            {
                path:'/session/explain',
                name:'sessionRule',
                component: resolve => require([`./views/meeting/sessionExplain`], resolve) /*拍卖会拍卖规则*/
            },
            {
                path:'/special/explain',
                name:'specialExplain',
                component: resolve => require([`./views/meeting/specialExplain`], resolve) /*拍卖专场拍卖规则*/
            },
            {
                path:'/organ/explain',
                name:'orgRule',
                component: resolve => require([`./views/organ/explain`], resolve) /*拍卖机构拍卖条款*/
            },
            {
                path:'/organ/list',
                name:'OrganList',
                component: resolve => require([`./views/organ/list`], resolve) /*拍卖机构列表*/
            },
            {
                path:'/select/company',
                name:'selectcompany',
                component: resolve => require([`./views/search/selectCompany`], resolve) /*选择拍卖公司*/
            },

            {
                path: "/organ/:organCode",
                name: 'meetinglist',
                component: resolve => require([`./views/organ/meeting`], resolve) /*机构拍卖会详情*/
            },
            {
                path: "/special/:specialCode",
                name: 'search_special',
                meta: {
                    keepAlive: true
                },
                component: Select, /*拍卖专场详情*/
            },
            {
                path: "/special2/:specialCode",
                name: 'search_special2',
                // component: Select, /*拍卖专场详情*/
                component: resolve => require([`./views/meeting/my`], resolve) /*拍卖会详情*/
            },
            /*拍卖会模块*/
            {
                path: "/session/:sessionCode",
                name: 'session',
                component: resolve => require([`./views/meeting/session`], resolve) /*拍卖会详情*/
            },
            {
                path: "/orgenPaper/:organCode",
                name: 'orgenPaper',
                component: resolve => require([`./views/orgenPaper`], resolve) /*证照信息*/
            },
            {
                path: "/culturalLicense",
                name: 'culturalLicense',
                component: resolve => require([`./views/culturalLicense`], resolve) /*证照信息*/
            },
            {
                path:'/sendInfor',
                name:'sendInfor',
                component :resolve => require([`./views/sendInfor`], resolve) /*我要送拍*/
            },
         
            {
                path:'/sendForm',
                name:'sendForm',
                component :resolve => require([`./views/sendForm`], resolve) /*送拍表单*/
            },

            
            {
                path:'/sendDetailOrgan',
                name:'sendDetailOrgan',
                component :resolve => require([`./views/sendDetailOrgan`], resolve) /*送拍机构查看*/
            },
            {
                path:'/sendDetailUser',
                name:'sendDetailUser',
                component :resolve => require([`./views/sendDetailUser`], resolve) /*送拍用户查看*/
            },   {
                path:'/sendListOrgan',
                name:'sendListOrgan',
                component :resolve => require([`./views/sendListOrgan`], resolve) /*送拍机构查看*/
            },
            {
                path:'/sendListUser',
                name:'sendListUser',
                component :resolve => require([`./views/sendListUser`], resolve) /*送拍用户查看*/
            },
            {
                path:'/privacy',
                name:'privacy',
                component :resolve => require([`./views/privacy`], resolve) /*隐私协议*/
            },
            {
                path:'/pageDefault',
                name:'pageDefault',
                component :resolve => require([`./views/privacy/pages/default`], resolve) /*隐私协议*/
            },
            {
                path:'/artLicence',
                name:'artLicence',
                component :resolve => require([`./views/artLicence`], resolve) /*证照信息*/
            },
            {
                path:'/highdefsyno',
                name:'highdefsyno',
                component :resolve => require([`./views/highdefsyno`], resolve) /*超清大图介绍页*/
            },
            {
                path:'/auctiondatasyno',
                name:'auctiondatasyno',
                component :resolve => require([`./views/auctiondatasyno`], resolve) /*拍卖数据介绍页*/
            },
            {
                path:'/sendsyno',
                name:'sendsyno',
                component :resolve => require([`./views/sendsyno`], resolve) /*送拍介绍页*/
            },
            {
                path:'/valuation',
                name:'valuation',
                component :resolve => require([`./views/valuation`], resolve) /*估值介绍页*/
            },
            {
                path:'/openApp',
                name:'openApp',
                component :resolve => require([`./views/openApp`], resolve) /*测试*/
            },
            {
                path:'/subscribeMsg',
                name:'subscribeMsg',
                component :resolve => require([`./views/subscribeMsg`], resolve) /*订阅信息*/
            },
            {
                path:'/memberActivity',
                name:'memberActivity',
                component :resolve => require([`./views/memberActivity`], resolve) /*会员活动*/
            },
            {
                path:'/bidspecialList',
                name:'/bidspecialList',
                component :resolve => require([`./views/bidspecialList`], resolve) /*聚合页*/
            },
            {
                path:'/bookcase',
                name:'/bookcase',
                component :resolve => require([`./views/bookcase`], resolve) /*电子书*/
            },
            {
                path:'/androidSdk',
                name:'androidSdk',
                component :resolve => require([`./views/androidSdk`], resolve) /*SDK*/
            },
            {
                path:'/androidTuluUserAgreement',
                name:'androidTuluUserAgreement',
                component :resolve => require([`./views/androidTuluUserAgreement`], resolve) /*用户协议*/
            },
            {
                path:'/embargoAgreement',
                name:'embargoAgreement',
                component :resolve => require([`./views/embargoAgreement`], resolve) /*禁限运*/
            },
            {
                path:'/sendUserAgreement',
                name:'sendUserAgreement',
                component :resolve => require([`./views/sendUserAgreement`], resolve) /*送拍功能用户协议*/
            },
            {
                path:'/metrics',
                name:'metrics',
                component :resolve => require([`./views/404`], resolve) /*404*/
            },
            {
                path: '/follow',
                name: 'follow',
                component: () => import('./views/follow/index.vue')
            },
            {
                path: '/recommend',
                name: 'recommend',
                component: () => import('./views/recommend/index.vue')
            },
            
            {
                path: '/myFollow',
                name: 'myFollow',
                component: () => import('./views/my/MyFollow.vue')
            },
            {
                path: '/topics',
                name: 'topics',
                component: () => import('./views/topics/index.vue')
            },
            {
                path: '/topics/:id',
                name: 'topicsDetail',
                component: () => import('./views/topics/detail.vue')
            },
            {
                path: '/recommendTopic/:id',
                name: 'recommendTopic',
                component: () => import('./views/topics/recommendTopic.vue')
            },
            {
                path: '/labelDetails',
                name: 'labelDetails',
                component: () => import('./views/labelDetails/index.vue')//标签详情页
            },
            {
                path: '/indexNew',
                name: 'indexNew',
                component: () => import('./views/indexNew.vue')
            },
            {
                path:'/:id',
                name:'idhome',
                component :resolve => require([`./views/index`], resolve) /*404*/
            },
            {
                path:'*',
                redirect:'/'
            }
        ]
    })
}

// const originalPush = vueRouter.prototype.push
// vueRouter.prototype.push = function push(location){
//     return originalPush.call(this,location).catch(err => err)
// }
// vueRouter.beforeEach((to, from, next) => {
//     if (to.matched.length === 0) {
//         next('/')
//     }
// })
